export const Markdown = ({ text }) => {
  const lines = (text || "").split("\n");
  const renderInline = (s, key) => {
    const parts = s.split(/(\*\*[^*]+\*\*)/g);
    return (
      <span key={key}>
        {parts.map((p, i) =>
          p.startsWith("**") && p.endsWith("**")
            ? <strong key={`${key}-b${i}-${p.slice(2, 12)}`} className="font-semibold text-stone-900">{p.slice(2, -2)}</strong>
            : p
        )}
      </span>
    );
  };
  return (
    <div className="space-y-2 text-sm leading-relaxed text-stone-700" data-testid="markdown-content">
      {lines.map((line, i) => {
        const s = line.trim();
        const k = `${i}-${s.slice(0, 24)}`;
        if (!s) return <div key={k} className="h-2" />;
        if (s.startsWith("### ")) return <h4 key={k} className="pt-3 font-heading text-base font-semibold text-stone-900">{renderInline(s.slice(4), k)}</h4>;
        if (s.startsWith("## ")) return <h3 key={k} className="pt-4 font-heading text-lg font-semibold text-stone-900">{renderInline(s.slice(3), k)}</h3>;
        if (s.startsWith("# ")) return <h2 key={k} className="pt-4 font-heading text-xl font-semibold tracking-tight text-stone-900">{renderInline(s.slice(2), k)}</h2>;
        if (/^[-•]\s/.test(s)) return (
          <div key={k} className="flex gap-2.5 pl-1">
            <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
            <span>{renderInline(s.replace(/^[-•]\s*/, ""), k)}</span>
          </div>
        );
        const numbered = s.match(/^(\d+)\.\s+(.*)$/);
        if (numbered) return (
          <div key={k} className="flex gap-2.5 pl-1">
            <span className="font-semibold text-primary">{numbered[1]}.</span>
            <span>{renderInline(numbered[2], k)}</span>
          </div>
        );
        return <p key={k}>{renderInline(s, k)}</p>;
      })}
    </div>
  );
};
